export const RADIOS_INITIAL_VALUES = {
	yes: false,
	no: false
};

export default {
	daily_field_record: {
		calc_disabled: false,
		crew_members: [],
		description_of_work: '',
		time_items: null,
		equipment: [],
		client_name: '',
		client_signature: null,
		supervisor_signature: null,
		supervisor_name: '',
		subconsultants: [],
		hours: {
			shop_1: { arrive: null, leave: null },
			site: { arrive: null, leave: null },
			shop_2: { arrive: null, leave: null },
			total: 0
		}
	},
	general_daily_toolbox: {
		crew: [],
		attendees: [],
		todays_tasks: '',
		conditions: {
			weather: '',
			temperature: ''
		},
		hazards: {
			known_hazards: '',
			other_hazards: '',
			hyperthermia_hypothermia: false,
			entrapment_entanglement_pinch: false,
			loss_of_consciousness: false,
			excavations_earthwork_activities: false,
			fuel_containers_leaks: false,
			confined_space_entry: false,
			mechanical_deficiencies: false,
			fall_protection: '',
			overhead: false,
			slips_trips_falls: false,
			tools: '',
			other: ''
		},
		protective_equipment: {
			hard_hat: false,
			safety_glasses: false,
			steel_toe_boots: false,
			gloves: false,
			safety_vests: false,
			hearing_protection: false,
			pfd: false,
			other: ''
		},
		emergency_procedures: {
			emergency_action_plan: false,
			first_aid_kit: false,
			fire_extinguishers: false,
			operational_emergency: false,
			emergency_notes: '',
			emergency_contacts: null,
			hospitals: null,
			hospital_name: null,
			hospital_phone_number: null,
			hospital_location: null
		},
		team_assessment: {
			able_to_perform_duties: false,
			restrictions: '',
			orange_hats: false,
			orange_hat_mentor: '',
			team_member: '',
			mentor: '',
			orange_hat_list: []
		}
	},
	pre_dive_meeting: {
		crew: [],
		attendees: [],
		hazards: {
			slips_trips_falls: false,
			overhead: false,
			burning_welding: false,
			safety_observations_discussed: false,
			known_hazards: '',
			other_hazards: ''
		},
		topics: {
			loss_of_air: false,
			confined_space_entry: false,
			tools: '',
			loss_of_communication: false,
			pump_suction: false,
			entrapment_entanglement: false,
			break_away_from_moored_station: false,
			underwater_debris: false,
			valves_pipes: false,
			emergency_action_plan: false,
			other: ''
		},
		dive_mode: {
			surface_supplied_air: false,
			scuba: false,
			wading: false,
			dive_plan: false,
			objective_of_dive: ''
		},
		thermal_protection: {
			wet_suit: false,
			dry_suit: false,
			hot_water: false,
			temp_setting: '',
			dive_modifications: ''
		},
		conditions: {
			water_temp: '',
			weather_temp: '',
			weather: '',
			water_current: '',
			maximum_depth: '',
			visibility: ''
		},
		protective_equipment: {
			hard_hat: false,
			safety_glasses: false,
			steel_toe_boots: false,
			gloves: false,
			safety_vests: false,
			hearing_protection: false,
			other: ''
		},
		team_assessment: {
			physically_fit: false,
			illnesses: false,
			fever_temperature_chills: false,
			taking_medications: false,
			ready_to_dive: false,
			relevant_information: '',
			orange_hats: false,
			team_member: '',
			mentor: '',
			orange_hat_list: [],
			orange_hat_mentor: ''
		},
		emergency_procedures: {
			first_aid_kit: false,
			fire_extinguishers: false,
			emergency_hp_air_system_pressure: false,
			cell_phone_2_way_radio_operational: false,
			aed: false,
			emergency_notes: '',
			emergency_contacts: null,
			hospitals: null,
			hospital_name: null,
			hospital_phone_number: null,
			hospital_location: null
		}
	},
	pre_dive_equipment_safety_list: {
		complete: false,
		surface_supplied_air: {
			dive_compressor: true,
			bottle_bank: false,
			dive_compressor_id: '',
			fuel: false,
			volume_tank: false,
			monolec_oil: false,
			filters: false,
			engine_oil: false,
			check_for_leaks: false,
			repairs_or_corrections_made: '',
			bottle_1_psi: '',
			bottle_1_regulated_to_psi: '',
			bottle_2_psi: '',
			bottle_2_regulated_to_psi: '',
			bottle_3_psi: '',
			bottle_3_regulated_to_psi: ''
		},
		reserve_air_supply: {
			hp_tank: {
				selected: false,
				text: ''
			},
			hp_tank_regulated_to: '',
			diver_1_bailout_bottle: {
				selected: false,
				text: ''
			},
			diver_2_bailout_bottle: {
				selected: false,
				text: ''
			},
			diver_3_bailout_bottle: {
				selected: false,
				text: ''
			},
			tanks_secure: false,
			repairs_or_corrections_made: ''
		},
		umbilicals_whips_pressure_gauges: {
			connection_tight: false,
			main_valves_open: false,
			check_for_leaks: false,
			repairs_or_corrections_made: ''
		},
		dive_helmets: {
			helmets: [],
			helmet: '',
			non_return_value: false,
			neck_dam: false,
			purge_valve: false,
			helmet_o_rings: false,
			oral_nasal: false,
			communications: false,
			kmb_hood: false,
			snoopy: false,
			repairs_or_corrections_made: ''
		},
		thermal_protection_suits: {
			wet_suit: false,
			dry_suit: false,
			inflate_valves: false,
			dry_suit_valves: false,
			hot_water: false,
			condition_of_suit: false,
			repairs_or_corrections_made: ''
		},
		communications: {
			batteries_charged: false,
			connections_good: false,
			test_diver_1: false,
			test_diver_2: false,
			repairs_or_corrections_made: ''
		},
		emergency_communication: {
			emergency_phone_list: false,
			marine_radio_test: false,
			cellular_phone_activated: false,
			repairs_or_corrections_made: ''
		},
		general: {
			dive_tables: false,
			dive_logs: false,
			dive_flags_out: false,
			fire_extinguishers_charged: false,
			dive_notes: false,
			dive_platform_securely_anchored: false,
			dive_knife: false,
			repairs_or_corrections_made: ''
		}
	},
	hazardous_energy_loto: {
		lockout_tagout_required: RADIOS_INITIAL_VALUES,
		concerns: {
			hydraulic_energy: {
				title: 'Hydraulic Energy',
				fields: {
					currents: {
						title: 'Currents',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					differential_pressure: {
						title: 'Differential Pressure',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					valves: {
						title: 'Valves',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					gates: {
						title: 'Gates',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					bulkheads: {
						title: 'Bulkheads',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					pipe_plugs: {
						title: 'Pipe Plugs',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					wickets: {
						title: 'Wickets',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					dams_canals_penstocks: {
						title: 'Dams/Canals/Penstocks',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					liftbags: {
						title: 'Liftbags',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					airlifts: {
						title: 'Airlifts',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					other: {
						title: 'Other',
						other: '',
						verified: false,
						...RADIOS_INITIAL_VALUES
					}
				}
			},
			ship_husbandry: {
				title: 'Ship Husbandry (inspecting or around ships)',
				fields: {
					sonar_pule_transducers: {
						title: 'Sonar/Pulse Transducers',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					cathodic_protection: {
						title: 'Cathodic Protection',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					propellers: {
						title: 'Propellers',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					trim_tabs: {
						title: 'Trim Tabs',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					rudders: {
						title: 'Rudders',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					intakes_ship_services: {
						title: 'Intakes for Ship Services (Fire Suppression, Coolant, Ballast, etc.)',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					other: {
						title: 'Other',
						other: '',
						verified: false,
						...RADIOS_INITIAL_VALUES
					}
				}
			},
			electrical_energy: {
				title: 'Electrical Energy',
				fields: {
					amperage_current: {
						title: 'Amperage/Current',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					power_cables: {
						title: 'Power Cables',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					active_cathodic_protection_system: {
						title: 'Active Cathodic Protection System',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					welding_burning_activities: {
						title: 'Welding/Burning Activities',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					other: {
						title: 'Other',
						other: '',
						verified: false,
						...RADIOS_INITIAL_VALUES
					}
				}
			},
			mechanical_energy: {
				title: 'Mechanical Energy',
				fields: {
					pumps: {
						title: 'Pumps',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					turbines: {
						title: 'Turbines',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					restricted_restrained: {
						title: 'Restricted/Restrained (Spring Force)',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					gravity: {
						title: 'Gravity',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					lifting_pulling_devices: {
						title: 'Lifting/Pulling Devices (Cranes, Pullers)',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					tools: {
						title: 'Tools',
						verified: false,
						...RADIOS_INITIAL_VALUES
					},
					other: {
						title: 'Other',
						other: '',
						verified: false,
						...RADIOS_INITIAL_VALUES
					}
				}
			}
		},
		source_type_energy: '',
		risks_zero_energy_diver_ingress_egress: '',
		project_manager_name: '',
		project_manager_signature: '',
		supervisor_name: '',
		supervisor_signature: ''
	},
	delta_p_list: {
		complete: false,
		dive_planning: {
			scope_of_work: RADIOS_INITIAL_VALUES,
			potential_hazards: '',
			site_personnel: RADIOS_INITIAL_VALUES,
			designated_facility_contact: RADIOS_INITIAL_VALUES,
			designated_facility_personnel: [], // {name: '', phone_number_contact_method: ''}
			designated_facility_contact_name: '',
			designated_facility_phone_number_contact_method: '',
			direct_authority_onsite: RADIOS_INITIAL_VALUES,
			direct_authority_personnel: [], // {name: '', phone_number_contact_method: ''}
			direct_authority_onsite_name: '',
			direct_authority_onsite_phone_number_contact_method: ''
		},
		mitigation_plan: {
			review_facility: false,
			delta_p_hazards_site_representatives: '',
			lockout_tagout_plan: false,
			emergency_procedures: '',
			emergency_assets: '',
			capture_zone_min_safe_distance: false,
			diver_location_minimize_exposure: false,
			physical_barriers: RADIOS_INITIAL_VALUES,
			physical_barriers_plan: false,
			plan_discussed: false,
			systems_locations_confirmed: RADIOS_INITIAL_VALUES,
			risks_plan_established: false
		}
	},
	delta_p_field_list: {
		crew: [],
		delta_p_hazards: RADIOS_INITIAL_VALUES,
		delta_p_hazards_acknowledged: false,
		potential_hazards: '',
		delta_p_hazards_located: false,
		work_conducted_delta_p_eliminated: false,
		structure_layout_delta_p: false,
		capture_zone_reviewed: false,
		established_location_reviewed: false,
		original_plan_modified: RADIOS_INITIAL_VALUES,
		location_changed_reason: '',
		lockout_tagout_plan_implemented: false,
		lockout_tagout_plan_reviewed: false,
		physical_barriers_verified: false,
		no_flow_conditions: false,
		conditions_diver_plan: false,
		diver_communicate_monitored_tracked: false,
		diver_tended: false,
		water_flow_report_change: false,
		emergency_assets: '',
		emergency_procedures: ''
	}
};
